export const TeamHeader = [
  {
    name: "Loan Account",
    field: "loan_acc",
  },
  {
    name: "Loan Amount",
    field: "loan_amt",
  },
  {
    name: "Loan EMI",
    field: "loan_emi",
  },
  {
    name: "Start From",
    field: "start_from",
  },
  {
    name: "Updated amount",
    field: "updated_amt",
  },
  {
    name: "Action",
    field: "action",
  },
];
